var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"font-size":"15px","padding":"10px"}},[_c('div',{staticStyle:{"font-weight":"bold"}},[_vm._t("title")],2),_c('div',[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }